import * as React from "react";
import { Field } from "formik";

interface IFormFieldProps {
	name: string;
	className: string;
	placeholder: string;
	component?: string;
	type?: string;
	errors: any;
	touched: any;
	colorTheme: string;
	children?: string | JSX.Element | JSX.Element[];
	isColumn: boolean;
	value?: React.ReactNode;
	as?: React.ReactNode | JSX.Element | JSX.Element[];
}

const FormField: React.FC<IFormFieldProps> = (props) => {
	const getClassName = () => {
		if (props.isColumn) {
			return "col-md-12 my-1 px-4";
		} else {
			return "col-md-6 my-2";
		}
	};
	return (
		<div className={getClassName()}>
			<Field
				className={`${props.className} no-border ${
					props.errors[props.name] && props.touched[props.name]
						? "error-validation-" + props.colorTheme
						: null
				}`}
				type={props.type}
				name={props.name}
				placeholder={props.placeholder}
				component={props.component}
				as={props.as}
			>
				{props.children}
			</Field>
		</div>
	);
};

export default FormField;
